module.exports = __webpack_public_path__ + "img/web.bf3b5c93.svg";